// Central content for Banga Bowls

export const INFO = {
  name: "Banga Bowls",
  tagline: "Afrikanisches Street Food. Mitten in der Bar.",
  city: "Zürich",
  address: "Adresse folgt · Zürich",
  hours: "Abends bis spät · Do–Sa",
  email: "hallo@bangabowls.ch",
  phone: "+41 00 000 00 00",
  instagram: "@bangabowls",
  instagramUrl: "https://instagram.com",
};

export const IMAGES = {
  heroBowl: "https://images.pexels.com/photos/17952746/pexels-photo-17952746.jpeg",
  jollof: "https://images.pexels.com/photos/17952748/pexels-photo-17952748.jpeg",
  darkDish: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea",
  barNeon: "https://images.unsplash.com/photo-1503876466-1fc5143eda57",
  martiniNeon: "https://images.unsplash.com/photo-1742650184160-20526612b025",
  portrait: "https://images.pexels.com/photos/14633029/pexels-photo-14633029.jpeg",
  fire: "https://images.pexels.com/photos/21077136/pexels-photo-21077136.jpeg",
  cornDark: "https://images.unsplash.com/photo-1626974348997-e0b8a8ef3111",
  bowl2: "https://images.unsplash.com/photo-1664992960082-0ea299a9c53e",
  fruit: "https://images.unsplash.com/photo-1539896530773-e891aa12b83b",
};

export const CHAPTERS = [
  {
    n: "01",
    title: "Zum Teilen",
    text: "Alles ist gemacht, um es rumzureichen und gemeinsam zu probieren. Boxen wandern über den Tisch, Hände greifen rein, niemand isst allein.",
  },
  {
    n: "02",
    title: "Unkompliziert",
    text: "Gute Box, Hand, fertig. Kein Chichi, kein steifer Service. Das Essen ist der Star, alles andere darf sich zurücknehmen.",
  },
  {
    n: "03",
    title: "Bis spät",
    text: "Die Küche läuft in den Abend hinein, danach übernimmt die Bar. Die Musik wird einen Tick lauter, und keiner will so recht gehen.",
  },
];

export const MENU_SAVORY = {
  label: "Herzhaft & würzig",
  sub: "Sechs Gerichte, kein Füllmaterial. Jedes für sich ein Grund herzukommen.",
  items: [
    {
      n: "01",
      name: "Merguez Sandwich",
      origin: "Nordafrika",
      price: "14.50",
      desc: "Würzige Merguez, Harissa, Tomaten, Zwiebeln, Salat und frische Kräuter im knusprigen Brot. Scharf, saftig und direkt, so wie Strassenküche aus dem Maghreb sein soll.",
      tags: ["scharf"],
    },
    {
      n: "02",
      name: "Jollof Plantain Chicken",
      origin: "Westafrika",
      price: "16.50",
      desc: "Rauchiger Jollof-Reis, gebratene Kochbananen und saftiges Poulet, das Herzstück der Karte. Dazu Sauce nach Wahl: Maafé (Erdnuss) oder Obe Ata (Tomate). Auch komplett vegan für CHF 14.50.",
      tags: ["vegan möglich"],
    },
    {
      n: "03",
      name: "Tasty Crousty",
      origin: "Viral aus Paris",
      price: "16.50",
      desc: "Knuspriges Poulet auf fluffigem Reis, cremige Sauce und ein Schuss süsse Schärfe. Der virale Streetfood-Hit aus Paris und London, jetzt bei uns.",
      tags: ["crunchy"],
    },
  ],
};

export const MENU_FRESH = {
  label: "Frisch & knusprig",
  sub: "Der leichte Gegenpol, und das, was einfach immer dazugehört.",
  items: [
    {
      n: "04",
      name: "Roter Couscous",
      origin: "Vegetarisch",
      price: "13.50",
      desc: "Roter Couscous mit Feta, Gurke, Tomaten, Datteln, Minze, Peperoncini und Limette. Leicht, frisch und trotzdem voller Würze.",
      tags: ["vegetarisch"],
    },
    {
      n: "05",
      name: "Mango Bowl",
      origin: "Frisch",
      price: "9.50",
      desc: "Cremige Mango-Bowl mit frischen Früchten, Crunch und Kokos. Die frische, süsse Antwort auf alles Würzige davor.",
      tags: ["süss"],
    },
    {
      n: "06",
      name: "Pommes",
      origin: "Dazu",
      price: "6.50",
      desc: "Knusprige Pommes, der Klassiker, der zu allem passt. Dazu zwei Saucen zur Wahl: Sauce Algerienne & Sauce Samouraï.",
      tags: ["classic"],
    },
  ],
};

export const MARQUEE_WORDS = [
  "MAGHREB MEETS WEST AFRICA",
  "ZUM TEILEN",
  "BIS SPÄT",
  "WÜRZIG & EHRLICH",
];
